import * as Sentry from '@sentry/browser';
import {TFunction} from 'i18next';
import {toast} from 'react-toastify';

import {BadGatewayError, GatewayTimeoutError, HttpError} from 'services/Effect/errors';

type PollingTags = {
  context: string; // example: 'PDF Upload API error'
  projectId: string;
  fileName: string; // file.name || 'unknown file name'
};

export function handlePollingErrors(error: unknown, t: TFunction, tags: PollingTags) {
  Sentry.captureException(error, {tags});
  if (error instanceof BadGatewayError || error instanceof GatewayTimeoutError) {
    toast.error(t('errors:polling.connection_issue', 'Connection issue detected. Please try again.'));
  } else if (error instanceof HttpError) {
    toast.error(t('errors:polling.server_error', 'Server error occurred'));
  } else {
    toast.error(t('errors:polling.upload_failed', 'File upload failed'));
  }
  return null;
}
